<template>
    <div class="container container-noticies-block">
        <div class="row">
            <div class="col-12">
                <div class="container-title">
                <p>Diversão e variedades</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 col-lg-3 container-banner__noticies-featured" v-for="noticia in grandes" :key="noticia.id">
                <router-link :to="noticia.url" target="_self" class="noticies-item">
                    <div class="noticies-item--image">
                        <img v-if="noticia.image" :src="utils.image(noticia.image, 265, 400)" alt="">
                    </div>
                    <div class="noticies-item--info">
                        <p class="noticies__label"><strong>{{noticia.hat || noticia.editorial.title}}</strong></p>
                        <p class="noticies__title noticies__title--white"><strong>{{ noticia.title }}</strong></p>
                    </div>
                </router-link>
            </div>
            <div class="col-12 col-lg-6">
                <div class="row">
                    <div class="col-12 col-md-4 col-lg-4" v-for="noticia in pequenas" :key="noticia.id">
                        <router-link :to="noticia.url" target="_self" class="noticies-item noticies-item--small">
                            <div class="noticies-item--image">
                                <img v-if="noticia.image" :src="utils.image(noticia.image, 160, 104)" alt="">
                            </div>
                            <p class="noticies__label noticies__label--black">{{noticia.hat || noticia.editorial.title}}</p>
                            <p class="noticies__title noticies__title--orange"><strong>{{ noticia.title }}</strong></p>
                        </router-link>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-6" v-for="noticia in medias" :key="noticia.id">
                        <router-link :to="noticia.url" target="_self" class="noticies-item --agenda">
                            <div class="noticies-item--image">
                                <img v-if="noticia.image" :src="utils.image(noticia.image, 256, 176)" alt="">
                            </div>
                            <div class="noticies-item--info">
                                <p class="noticies__label"><strong>{{noticia.hat || noticia.editorial.title}}</strong></p>
                                <p class="noticies__title noticies__title--white"><strong>{{noticia.title}}</strong></p>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import utils from '@/utils'

export default {
    name:'Diversao',
    data: function() {
        return {
            grandes:[],
            medias:[],
            pequenas:[],
            utils:utils,
        }
    },
    methods:{
        async getNoticias() {
            const response = await api.get('diversao/', {
                type:'news.NewsPage', 
                fields:'editorial,url,image,hat',
                order: '-first_published_at',
                limit:'7'
            })
            if(response.ok) {
                this.grandes = response.data.items.slice(0,2)
                this.medias = response.data.items.slice(2,4)
                this.pequenas = response.data.items.slice(4,7)
            }
        }
    },
    mounted() {
        this.getNoticias()
    }
}
</script>